import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-30 «Календар платежів» (F-007). Тека с этим файлом — и
// есть регистрация (`../registry.ts`): пункт раздела «Операції» оживает вместе с
// ней (решение 028). Входы — пункт меню, дело «прострочено» в «Потребує уваги»
// (если календарь человеку выдан) и прямой адрес `/s-30` (`?on=` — день).
export const meta: SurfaceMeta = {
  code: "S-30",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s30_title");
  },
  path: "/s-30",
};
